<ng-container [formGroup]="jobsiteForm">
  <div class="card-body add_bider_draw">
    <h2>Job Site</h2>
    <div class="form-row">
      <div class="form-group col-12">
        <label class="custom_label">Job Site *</label>
        <div class="input_with_external_btn">
          <ng-select
            id="jobsite_id"
            [items]="jobsites"
            placeholder="Select Job sites"
            [closeOnSelect]="true"
            formControlName="jobsite_id"
            bindLabel="{{coreService.ngSelectBindLabel}}"
            (change)="onSelectJobsite($event)"
            >
          </ng-select>
          <button (click)="addNewJobSite($event)" [appPermission]="'JOBSITE-BIDS-RELATED-CREATE'" class="btn_add_more_sm">+</button>
        </div>
        <app-validation-error [formGroup]="jobsiteForm" [controlName]="'jobsite_id'"></app-validation-error>
      </div>
    </div>

    @if (addNewJobSiteFlag) {
      <div class="form-group col-12">
        <label for="name" class="custom_label"> Name *</label>
        <input type="text" #htmlInputElement id="name" formControlName="name" class="form-control"
          placeholder="Warehouse Name" name="name">
        <app-validation-error [formGroup]="jobsiteForm" [controlName]="'name'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="email" class="custom_label"> Email *</label>
        <input type="email" id="email" formControlName="email" class="form-control" placeholder="Warehouse Email"
          name="email">
        <app-validation-error [formGroup]="jobsiteForm" [controlName]="'email'"></app-validation-error>
      </div>
      <div class="form-group col-12">
        <label for="phone" class="custom_label"> Phone *</label>
        <input type="tel" id="phone" formControlName="phone" phoneMask class="form-control"
          placeholder="Warehouse Phone" name="phone">
        <app-validation-error [formGroup]="jobsiteForm" [controlName]="'phone'"></app-validation-error>
      </div>
    }

    <app-address [isRequired]="true" [populateFormOnChanges]="jobSiteAddressChangesFlag"
      (callback)="initChildForm($event.value)" formControlName="jobsiteAddress" [form]="form"
    [model]="addressComponentData"></app-address>

  </div>
</ng-container>
